export default function fieldValidator(field, fields) {
  let anyFieldError = false

  const isRequired = field.rules && field.rules.includes('required')
  const isEmail = field.rules && field.rules.includes('email')
  const value = field.value || null

    let confirmationFields = []
    if(field.rules) {
        field.rules.forEach((rule) => {
            if (rule.startsWith('confirmation:')) {
                const fieldToConfirm = rule.split(':')[1]
                confirmationFields.push(fieldToConfirm)
            }
        })
    }

  if (isRequired && !value) {
    anyFieldError = true
  } else if (isEmail && value) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const validateEmail = re.test(String(value).toLowerCase())

    if (!validateEmail) {
      anyFieldError = true
    }
  }

  if(!anyFieldError && confirmationFields.length > 0){
        confirmationFields.forEach((fieldName) => {
            const fieldToConfirm = fields.find(f => f.name === fieldName)
            if(fieldToConfirm){
                if(fieldToConfirm.value !== field.value){
                    anyFieldError = true
                }
            }
        })
  }

  field.error = anyFieldError

  return !anyFieldError
}
